import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, FormGroup, FormControl, Table } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import CircumstancesPopup from './CircumstancesPopup';

class SelectWork extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
    };
  }

  openModal(e) {
    e.preventDefault();
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  hasSelected(work) {
    const { fields } = this.props;
    const works = fields.works || [];
    const index = R.findIndex(R.propEq('id', work.id))(works);

    return index !== -1;
  }

  selectWork(work) {
    const { fields } = this.props;
    let works = fields.works || [];
    let workTitles = fields.workTitles || [];

    if (fields.workType === 'single' && workTitles.length > 0) {
      this.props.alert(
        'error',
        'Sorry, you can only select one work. To register more works, go back and select the "Multiple Works" option.'
      );
      return;
    }

    if (!fields.publishInfoStatus && workTitles.length > 9) {
      this.props.alert(
        'error',
        'Sorry, you can only list up to 10 unpublished titles per application. If you want to register more unpublished titles, you will have to create another application.'
      );
      return;
    }

    works = R.filter((work2) => work2.team === work.team, works);
    const index = R.findIndex(R.propEq('id', work.id))(works);

    if (index === -1) {
      works.push(work);

      if (works[0].team !== -1) {
        this.props.loadTeamMembers(works[0].team);
      }

      let workTitles2 = works.map((work2) => {
        const index2 = R.findIndex(R.propEq('id', work2.id))(workTitles);
        if (index2 === -1) {
          return { id: work2.id, title: work2.name };
        } else {
          return workTitles[index2];
        }
      });

      if (fields.newWork === true) {
        const addtionalWorkTitles = R.filter(
          (workTitle) => workTitle.id === -1
        )(workTitles);
        workTitles2 = [...addtionalWorkTitles, ...workTitles2];
      }

      this.props.assignAttribute('works', [...works]);
      this.props.assignAttribute('workTitles', workTitles2);
    }
  }

  deselectWork(work) {
    const { fields } = this.props;
    const works = fields.works || [];
    const workTitles = fields.workTitles || [];

    let index = R.findIndex(R.propEq('id', work.id))(works);
    if (index !== -1) {
      works.splice(index, 1);
    }

    index = R.findIndex(R.propEq('id', work.id))(workTitles);
    if (index !== -1) {
      workTitles.splice(index, 1);
    }

    this.props.assignAttribute('works', [...works]);
    this.props.assignAttribute('workTitles', [...workTitles]);
  }

  deselectWorkTitle(workTitle, splitIndex) {
    const { fields } = this.props;
    const works = fields.works || [];
    let workTitles = fields.workTitles || [];

    const workIndex = R.findIndex(R.propEq('id', workTitle.id))(works);
    const index = R.findIndex(R.propEq('id', workTitle.id))(workTitles);

    if (index !== -1) {
      const titles = workTitles[index].title.split(';');

      if (titles.length === 1) {
        workTitles.splice(index, 1);

        if (workIndex !== -1) {
          works.splice(workIndex, 1);
        }
      } else {
        titles.splice(splitIndex, 1);

        if (titles.length === 0) {
          if (workIndex !== -1) {
            works.splice(workIndex, 1);
          }
        } else {
          workTitles[index].title = titles.join(';');
        }
      }
    }

    this.props.assignAttribute('workTitles', [...workTitles]);
  }

  addWorkTitle() {
    const { fields } = this.props;

    let workTitles = fields.workTitles || [];

    if (fields.workType === 'single' && workTitles.length > 0) {
      this.props.alert(
        'error',
        'Sorry, you can only select one work. To register more works, go back and select the "Multiple Works" option.'
      );
      return;
    }

    if (!fields.publishInfoStatus && workTitles.length > 9) {
      this.props.alert(
        'error',
        'Sorry, you can only list up to 10 unpublished titles per application. If you want to register more unpublished titles, you will have to create another application.'
      );
      return;
    }

    workTitles = [...workTitles, { id: -1, title: '' }];

    this.props.assignAttribute('workTitles', [...workTitles]);

    if (fields.newWork === false || !fields.newWork) {
      this.props.assignAttribute('newWork', true);
    }
  }

  removeWorkTitle(index) {
    const { fields } = this.props;
    const workTitles = fields.workTitles || [];

    workTitles.splice(index, 1);
    this.props.assignAttribute('workTitles', [...workTitles]);
  }

  handleWorkTitle(e, index, splitIndex) {
    const { fields } = this.props;
    const workTitles = fields.workTitles || [];

    const titles = workTitles[index].title.split(';');
    if (titles.length === 0) {
      workTitles[index].title = e.target.value;
    } else {
      titles[splitIndex] = e.target.value;
      workTitles[index].title = titles.join(';');
    }

    this.props.assignAttribute('workTitles', [...workTitles]);
  }

  handleNext() {
    const { fields } = this.props;

    this.props.hideAlert();
    let checked = true;

    if (fields.workTitles && fields.workTitles.length > 0) {
      checked =
        checked && fields.workTitles.every((workTitle) => !!workTitle.title);
    } else {
      checked = false;
    }

    if (checked) {
      this.props.assignAttribute('authors', []);
      this.props.router.push('/copyright-reg/authors');
    } else {
      this.props.alert('error', 'Please check the required fields.');
    }
  }

  renderWorks() {
    const { fields, works, /*workTypes,*/ teams /*deals*/ } = this.props;
    const filteredWorks = R.filter((work) => work.type === fields.type, works);

    return (
      filteredWorks && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Team</th>
                {/* <th>Type</th>
                            <th>Agreement</th> */}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredWorks.map((work, i) => {
                // const workType = R.find(R.propEq('id', work.type))(workTypes);
                const team = R.find(R.propEq('id', work.team))(
                  teams.filter((team) => team.archived === false)
                );
                // const agreement = R.find(R.propEq('agreement', work.agreement))(deals);
                const selected = this.hasSelected(work);

                return (
                  <tr key={i}>
                    <td>{work.name}</td>
                    <td>{team ? team.name : ''}</td>
                    {/* <td>{workType ? workType.name : ''}</td>
                                    <td>{agreement ? agreement.agreement_info.name : ''}</td> */}
                    <td>
                      {selected ? (
                        <a onClick={(e) => this.deselectWork(work)}>Deselect</a>
                      ) : (
                        <a onClick={(e) => this.selectWork(work)}>Select</a>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  renderTitles() {
    const { fields } = this.props;
    const workTitles = fields.workTitles || [];

    if (workTitles.length > 0) {
      return (
        <div>
          {workTitles.map((workTitle, index) => {
            const titles = workTitle.title.split(';');

            return titles.map((title, splitIndex) => (
              <div
                key={index + ' + ' + splitIndex}
                className="application-works"
              >
                <FormControl
                  type="text"
                  placeholder="Type Here"
                  value={title}
                  onChange={(e) => this.handleWorkTitle(e, index, splitIndex)}
                />

                {workTitle.id === -1 ? (
                  <a onClick={(e) => this.removeWorkTitle(index)}>remove</a>
                ) : (
                  <a
                    onClick={(e) =>
                      this.deselectWorkTitle(workTitle, splitIndex)
                    }
                  >
                    remove
                  </a>
                )}
              </div>
            ));
          })}
        </div>
      );
    }

    return null;
  }

  handleBack() {
    this.props.assignAttribute('works', []);
    this.props.assignAttribute('workTitles', []);
    this.props.router.goBack();
  }

  render() {
    return (
      <div className="select-work">
        <Heading text="Add Your Work Titles" />

        <div className="content">
          <p>
            <span className="sub-title">
              Add titles to your application manually or by selecting titles
              stored in your Cosynd profile. You can register mutiple titles in{' '}
              <a onClick={(e) => this.openModal(e)}>certain circumstances</a>.
              If you are registering a collection, list your titles in the order
              that they appear in the collection.
            </span>
            <br />
            <br />
          </p>

          <Form>
            <Row>
              <Col md={6} sm={12}>
                <Row>
                  <Col md={12} sm={12} className="add-title-button">
                    <div
                      className="add-view"
                      onClick={(e) => this.addWorkTitle()}
                    >
                      <div className="another">+ Add Title</div>
                    </div>
                  </Col>
                  <Col md={12} sm={12}>
                    <span className="sub-title">
                      Works included on this application:
                    </span>
                    <FormGroup className="work-title">
                      {this.renderTitles()}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>

              <Col md={6} sm={12}>
                <Row>
                  <br />
                  <div className="col-md-12 col-sm-12">
                    <p className="text-center">
                      <b>Add Titles From Your Profile:</b>
                    </p>
                  </div>
                  <Col md={12} sm={12}>
                    {this.renderWorks()}
                  </Col>
                </Row>
              </Col>
            </Row>
            <br />
            <br />
          </Form>
          <CircumstancesPopup
            open={this.state.openModal}
            onClose={() => this.closeModal()}
          />
        </div>

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handleBack()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  deals: state.deals.deals,
  teams: state.teams.teams,
  members: state.users.members,
  works: state.works.userWorks,
  profile: state.profile,
  workTypes: state.global.workTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  loadTeamMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectWork);



// WEBPACK FOOTER //
// src/components/Copyright/SelectWork.jsx